var React = require('react');

function Mr (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#cd2a3e","d":"M0 0h640v480H0z","key":0}),React.createElement("path",{"fill":"#006233","d":"M0 72h640v336H0z","key":1}),React.createElement("path",{"fill":"#ffc400","d":"M470 154.6a150 150 0 0 1-300 0 154.9 154.9 0 0 0-5 39.2 155 155 0 1 0 310 0 154.4 154.4 0 0 0-5-39.2z","className":"st1","key":2}),React.createElement("path",{"fill":"#ffc400","d":"M320 93.8l-13.5 41.5H263l35.3 25.6-13.5 41.4 35.3-25.6 35.3 25.6-13.5-41.4 35.3-25.6h-43.6z","key":3})]);
}

Mr.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Mr;

Mr.default = Mr;
